function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 4.167H3.192l2.983-2.992L5 0 0 5l5 5 1.175-1.183-2.983-2.984H15z",
  fillRule: "nonzero",
  fill: "#2C3137"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10"
  }, props), _ref);
};

export default SvgComponent;